import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Button } from '@/components/Button/Button'
import {
  NoAccountText,
  PoweredByLabel,
  TextInput,
} from '@/components/widget-components'
import { usePageStateStore } from '@/reducers'
import { PanelLayout } from './PanelLayout'

const KeyLoginPanel = () => {
  const setApiKey = usePageStateStore.use.setApiKey()
  const [paytrieKey, setKey] = useState<string>('')
  const navigate = useNavigate()

  const useApiKey = () => {
    // TODO: Determine actual key criteria
    if (paytrieKey.length > 10) {
      setApiKey(paytrieKey)
      navigate('/')
    }
  }

  return (
    <PanelLayout titleKey="welcome.title">
      <div className="flex flex-col gap-5" data-testid="container-key-login">
        <h2
          className="text-base font-normal uppercase"
          data-testid="text-key-login-title"
        >
          Key Login
        </h2>
        <div className="text-base" data-testid="text-key-login-description">
          Enter your unique key ID
        </div>
        <TextInput
          placeholder="Enter key"
          type="text"
          onChange={(e) => setKey(e.target.value)}
          value={paytrieKey}
          data-testid="input-key-login-key"
        />
        <Button
          disabled={paytrieKey.length < 10}
          onClick={useApiKey}
          data-testid="btn-key-login-send"
        >
          SEND
        </Button>
        <NoAccountText data-testid="text-key-login-no-account">
          don&apos;t have an account?{' '}
          <a
            className="cursor-pointer underline hover:text-clementine dark:hover:text-sun"
            onClick={() => navigate('/Signup')}
            data-testid="link-key-login-signup"
          >
            sign up
          </a>
          .
        </NoAccountText>
      </div>
      <PoweredByLabel data-testid="text-key-login-powered-by-label" />
    </PanelLayout>
  )
}

export default KeyLoginPanel
